<template>
	<div v-if="material" class="px-0 col-12">
		<div class="ml-auto pl-0 col-8">
			<blocker-product-table :product-id="material.product.id" :blocker-product-table-data="blockerProductTableData" class="mt-3" />
			<blocker-manual-table
			  :blocker-manual-table-data="blockerManualTableData"
				:product-id="material.product.id"
				:material-id="material.id"
				:asin="material.asin"
				v-on:saveEvent="reloadBlockerComputed"
				class="my-3"
			/>

			<div v-if="material != null">
				<material-stock-listings-editor
					:passed-material="material"
					:is-master="master"
					:user="user"
          :users="users"
          :blocker-computed-table-data="blockerComputedTableData"
          :synch-markets="synchMarkets"
          :product-categories="productCategories"
				></material-stock-listings-editor
				>
			</div>
		</div>
		<div
			v-if="material != null"
			class="col-4 pr-3 mt-3"
			style="position: fixed; top:59px; z-index:2;}"
		>
			<div class="mb-3">
				<form @submit="materialSearchFunction">
					<div class="input-group d-flex">
						<input
							type="text"
							style="text-align: left"
							v-bind:class="{
								'bg-danger': materialSearch.answer == false ? true : false,
								'form-control': true,
								'form-control-sm': true,
							}"
							placeholder="EAN / ASIN"
							v-model="materialSearch.code"
							ref="refEanSearch"
						/>
						<div class="input-group-append">
							<button class="btn btn-secondary btn-sm">Suchen</button>
						</div>
					</div>
				</form>
			</div>
			<div class="mb-1">
				<material-history-component :materialId="materialId"/>
			</div>
			<div class="card" v-bind:style="{ height: tHeight + 'px' }">
				<div class="card-body" style="overflow-y: scroll">
					<meta-data-panel
						:passed-material="material"
						:product-categories="productCategories"
						:passed-current-user="user"
					/>
				</div>
			</div>
		</div>

		<div>
			<!-- modal search wait dialogue-->
			<b-modal
				v-model="modalEanSearchState"
				size="sm"
				centered
				hide-footer
				hide-header
				no-close-on-esc
				no-close-on-backdrop
			>
				<div class="modal-body">
					<div class="text-center justify-content-between">Bitte Warten</div>
					<div class="row">
						<br /><br /><br />
						<div
							class="spinner-border text-center justify-content-between"
							style="
								position: fixed;
								z-index: 999;
								height: 3em;
								width: 3em;
								overflow: visible;
								margin: auto;
								top: 50px;
								left: 0;
								bottom: 0;
								right: 0;
							"
							role="status"
						>
							<span class="sr-only">Loading...</span>
						</div>
					</div>
				</div>
			</b-modal>
			<modal-error-component v-model="modalError"></modal-error-component>
		</div>
	</div>
</template>

<script>
import ModalErrorComponent from "../ModalErrorComponent.vue";
import MetaDataPanel from "./metadata/MetaDataPanel.vue";

export default {
	components: {MetaDataPanel},
	props: ["materialId", "userName", "isMaster", "userRole", "productCategories"],
	data() {
		return {
			showingBlockerProductTable: true,
			material: null,
			materialEditMaterial: null,
			modalError: {
				show: false,
				message: "Ein Fehler ist aufgetreten",
				error: "",
			},
			modalEanSearchState: false,
			materialSearch: {
				code: null,
				answer: null,
			},
			tHeight: window.innerHeight - 140,
			master: this.isMaster,
			user: {authorization: {}},
      users: [],
			mdsMarketRegions: {},
			blockerProductTableData: null,
			blockerComputedTableData: null,
			blockerManualTableData: null,
			synchMarkets: null
		};
	},
	methods: {
		reloadBlockerComputed() {
			axios.get(`/mds/blocker_computed/${this.material.product.id}`)
				.then((response) => {
					this.blockerComputedTableData.blockerComputed = response.data;
				})
				.catch((error) => {
					this.modalError = {
						show: true,
						title: "Material Interface Error",
						error: error.toString(),
					};
					console.error(error);
				});
		},
		materialSearchFunction(event) {
			event.preventDefault();
			this.modalEanSearchState = true;
			axios
				.get("/material/exists", { params: { code: this.materialSearch.code } })
				.then((response) => {
					this.modalEanSearchState = false;
					this.materialSearch.answer = response.data;
					if (this.materialSearch.answer != false) {
						window.location.replace(
							"/material/" + this.materialSearch.answer.id + "/edit"
						);
					}
				})
				.catch((error) => {
					console.dir(error);
					this.modalEanSearchState = false;
					this.modalError.title= "Material Interface Search Error";
					this.modalError.error = error.toString();
					this.modalError.show = true;
				});
		},
        updateStock(_stock){
		// console.log("MaterialInterface");
		
        }		
	},
	created() {
		axios.get("/material/get", { params: { materialId: this.materialId } })
			.then((response) => {
				this.material = response.data;

				Promise.all([
					axios.get(`/material/get_blocked_vendor_stocks/${this.materialId}`),
		      axios.get("/material/get_blockable_vendorIds"),
		      axios.get(`/material/get_last_manual_vendor_orders/${this.materialId}`),

		      axios.get(`/user/all`), // for materialStockListingsEditor
					axios.get('/user/self'), // for BlockerManualTable
					axios.get("/user/authorization"), // for materialStockListingsEditor


					axios.get('/blocker_manual_reason/all'), // for BlockerManualTable
					axios.get('/marketaccount/all_with_countries'), // for materialStockListingsEditor & BlockerComputedTable
					axios.get('/market/all'), // for materialStockListingsEditor & BlockerComputedTable
					axios.get('/country/all'),  // for BlockerProductTable

					axios.get(`/mds/region`), // for BlockerProductTable
					axios.get(`/mds/country`), // for BlockerProductTable
					axios.get("/mds/market"), // for BlockerProductTable

					axios.get(`/mds/blocker_computed/${this.material.product.id}`), // for BlockerComputedTable
					axios.get(`/mds/sales/by_product_id/${this.material.product.id}`), // for BlockerComputedTable
					axios.get(`/mds/blocker_manual/${this.material.product.id}`), // for BlockerManualTable
					axios.get(`/mds/blocker_list/by_product_id/${this.material.product.id}`), // for BlockerProductTable
					axios.get(`/mds/blocker_function/by_product_id/${this.material.product.id}`), // for BlockerProductTable
					axios.get(`/mds/blocker_automatic/by_product_id/${this.material.product.id}`), // for BlockerProductTable
				])
				.then(([blockedVendorsResponse, vsbResponse, mhResponse, allUsersResponse, userSelfResponse,
				 authorizationResponse, allBlockerManualReasonResponse, allMarketAccountsResponse, allMarketsResponse,
				 allCountriesResponse, mdsRegioResponse, mdsCountryResponse, mdsMarketResponse,  blockerComputedResponse,
				 productSalesResponse, blockerManualResponse, blockerListResponse, blockerFunctionResponse, blockerAutomaticResponse]) => {

					let blockedVendorStocks = vsbResponse.data;
					let blockableVendorIds = blockedVendorsResponse.data;
					this.material.materialHistory = mhResponse.data;
					this.countries = allCountriesResponse.data;

					this.user = userSelfResponse.data;
					this.user.authorization = authorizationResponse.data;
	        this.users = allUsersResponse.data;

					this.blockerManualTableData = {
						blockerManuals: blockerManualResponse.data,
						reasons: allBlockerManualReasonResponse.data,
						regions: mdsRegioResponse.data,
						countries: mdsCountryResponse.data,
						markets: mdsMarketResponse.data,
						user: userSelfResponse.data,
					};

					this.blockerProductTableData = {
						regions: mdsRegioResponse.data,
						countries: mdsCountryResponse.data,
						markets: mdsMarketResponse.data,
						blockerLists: blockerListResponse.data,
						blockerFunctions: blockerFunctionResponse.data,
						blockerAutomatics: blockerAutomaticResponse.data
					};

					this.blockerComputedTableData = {
						blockerComputed: blockerComputedResponse.data,
						productSales: productSalesResponse.data,
						marketAccounts: allMarketAccountsResponse.data,
						markets: allMarketsResponse.data,
						mdsMarkets: mdsMarketResponse.data,
					};

					this.synchMarkets = allMarketAccountsResponse.data;

	        if(this.material.materialHistory.length > 0){

	          this.material.materialHistory.map(mh => {

	            let data = JSON.parse(mh.diff);
	            mh.manualOrderQuantity = data.new["manuelle Bestellung"];
	            mh.manualOrderReference = data.old["manuelle Bestellung"];
	            return mh;
	          })
	        }


	        console.log(this.material)
					for (let stock of this.material.stocks) {

						let matchedStockBlock = blockedVendorStocks.find(
							vsb => vsb.stockId === stock.id
						);
						// console.log(matchedStockBlock);
						//weil vendorStockBlock nach initialisierung hinzugefügt wurde, wird es hier reactive gemacht
						this.$set(stock, 'vendorStockBlock', (matchedStockBlock == undefined ? false : true));
						this.$set(stock, 'blockableVendorIds', blockableVendorIds);

					}
					/*
					this.material.stocks.map( stock => {
						stock.vendorStockBlock = vendorStockBlocks.find( vsb => vsb.vendorId == vendor.id );
					});
	*/
					let categoryNames = [];
					Object.values(this.productCategories).forEach(category => {
						categoryNames[category.categoryId] = category.uiName;
					});
					this.material.categoryName = categoryNames[this.material.category];


					//Data Prep

					//1. MarketAccountHistory
					//each stock's marketaccountstock must be assigned a set of five (sorted from 0 to 5) PriceStateHistory objects
					// this is used in the popper, and also in the main table (merchPrice, PS, etc. of priceState with HistoryId := 0).

					for (let stock of this.material.stocks) {
						for (let mas of stock.marketaccountstocks) {
							let history = [];

							for (let pri of this.material.priceInfoHistories) {
								let matchingMA = pri.marketAccountId == mas.marketAccountId;
								let matchingCondition =
										pri.articleCondition == mas.articleCondition;

								if (matchingMA && matchingCondition) {
									history.push(pri);
								}

								//sort histories by HistoryId, descending

								history.sort((v, w) => {
									return Number(v.historyId) - Number(w.historyId);
								});

								mas.priceInfoHistories = history;
							}
							for (let marketAccount in this.material.marketMirrorData) {
								if(marketAccount == mas.marketaccount.mdsMarketIdentifier) {
									mas.marketMirrorData = this.material.marketMirrorData[marketAccount];
								}
							}
						}
					}


					//sort stocks according to pruchasePrices
					this.material.stocks.sort((v, w) => {
						return Number(v.purchasePrice) - Number(w.purchasePrice);
					});

					// MarketAccountStock data prep, sets:
					// mas.priceState, mas.priceStateColor, mas.currencySymbol
					for (let stock of this.material.stocks) {
						for (let mas of stock.marketaccountstocks) {
							//we could do this calc in the above loop, but for the sake of readability, it is split.
							//Shouldn't cost more than a few milliseconds (like 7 at most).
							let currencyIso = mas.marketaccount.country.currencyIso;
							// +++ Currency Symbol data prep
							if (currencyIso == "EUR") {
								mas.currencySymbol = "€";
							} else if (currencyIso == "USD") {
								mas.currencySymbol = "$";
							} else if (currencyIso == "GBP") {
								mas.currencySymbol = "£";
							} else {
								mas.currencySymbol = currencyIso;
							}

							// +++ PS text color data prep
							mas.priceState = null;

							if (mas.priceInfoHistories?.length == 0) {
								mas.priceState = 0;
							} else {
								mas.priceState = mas.priceInfoHistories?.[0].priceState;
							}

							mas.priceStateStyle = "black";

							if (mas.priceState != null) {
								if (mas.priceState >= 50 && mas.priceState <= 65) {
									mas.priceStateStyle = "green";
								} else if (
										(mas.priceState >= 70 && mas.priceState <= 75) ||
										(mas.priceState >= 20 && mas.priceState <= 25) ||
										(mas.priceState >= 30 && mas.priceState <= 35)
								) {
									mas.priceStateStyle = "orange";
								} else {
									mas.priceStateStyle = "red";
								}
							}
						}
					}

					//strip Material for Edit Material Component:
					this.materialEditMaterial = {
						id: this.material.id,
						ean: this.material.ean,
						eans: this.material.eans,
						upc: this.material.upc,
						isbn: this.material.isbn,
						asin: this.material.asin,
						category: this.material.category,
						name: this.material.name,
						description: this.material.description,
						producer: this.material.producer,
						isBlocked: this.material.isBlocked,
						isUndeliverable: this.material.isUndeliverable,
						needsMetaData: this.material.needsMetaData,
						inMaterialSince: this.material.inMaterialSince,
						priority: this.material.priority,
						currentState: this.material.currentState,
						lastUpdateTime: this.material.lastUpdateTime,
						lastUpdateUser: this.material.lastUpdateUser,
						lastUpdateReason: this.material.lastUpdateReason,
					};
				})
				.catch((error) => {
					this.modalError = {
						show: true,
						title: "Material Interface Error",
						error: error.toString(),
					};
					console.error(error);
				});
			}).catch((error) => {
				this.modalError = {
					show: true,
					title: "Material Interface Error",
					error: error.toString(),
				};
				console.error(error);
			});
	},

	mounted() {
		// alters url pathname without redirecting
		window.history.pushState("", "", "/material/" + this.materialId + "/edit");
		//see: window.history.replaceState(data, title, url)
		//web: stackoverflow.com/q/12446317
		this.$nextTick(() => {
			window.addEventListener("resize", () => {
				this.tHeight = window.innerHeight - 140;
			});
			setTimeout(() => this.$refs.refEanSearch.focus(), 2000);
		});
	},
};
</script>